import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMillPulverizerHammer = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 100,
	height: 60,
	viewBox: "0 0 100.0 60.0",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M 0.0 0.0 L 100.0 0.0 L 80.0 60.0 L 20.0 60.0 Z",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	}), /* @__PURE__ */ _jsx("path", {
		d: "M 25.0 0.0 L 8.0 25.0 M 75.0 0.0 L 92.0 25.0 M 40.0 40.0 L 60.0 20.0 M 40.0 20.0 L 60.0 40.0 M 43.0 17.0 L 37.0 23.0 M 37.0 37.0 L 43.0 43.0 M 63.0 37.0 L 57.0 43.0 M 57.0 17.0 L 63.0 23.0",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 1
	})]
});
export default SvgMillPulverizerHammer;
